/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUpgradeCertificateRequest
 */
export interface UpdateUpgradeCertificateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeCertificateRequest
     */
    loyaltyAccountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeCertificateRequest
     */
    programName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeCertificateRequest
     */
    certificateType?: UpdateUpgradeCertificateRequestCertificateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateUpgradeCertificateRequest
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUpgradeCertificateRequest
     */
    remainingCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateUpgradeCertificateRequest
     */
    expirationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeCertificateRequest
     */
    notes?: string | null;
}


/**
 * @export
 */
export const UpdateUpgradeCertificateRequestCertificateTypeEnum = {
    Nua: 'nua',
    Sua: 'sua',
    Cur: 'cur',
    IhgSuiteUpgrade: 'ihg_suite_upgrade'
} as const;
export type UpdateUpgradeCertificateRequestCertificateTypeEnum = typeof UpdateUpgradeCertificateRequestCertificateTypeEnum[keyof typeof UpdateUpgradeCertificateRequestCertificateTypeEnum];


/**
 * Check if a given object implements the UpdateUpgradeCertificateRequest interface.
 */
export function instanceOfUpdateUpgradeCertificateRequest(value: object): value is UpdateUpgradeCertificateRequest {
    return true;
}

export function UpdateUpgradeCertificateRequestFromJSON(json: any): UpdateUpgradeCertificateRequest {
    return UpdateUpgradeCertificateRequestFromJSONTyped(json, false);
}

export function UpdateUpgradeCertificateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUpgradeCertificateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'programName': json['program_name'] == null ? undefined : json['program_name'],
        'certificateType': json['certificate_type'] == null ? undefined : json['certificate_type'],
        'totalCount': json['total_count'] == null ? undefined : json['total_count'],
        'remainingCount': json['remaining_count'] == null ? undefined : json['remaining_count'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateUpgradeCertificateRequestToJSON(json: any): UpdateUpgradeCertificateRequest {
    return UpdateUpgradeCertificateRequestToJSONTyped(json, false);
}

export function UpdateUpgradeCertificateRequestToJSONTyped(value?: UpdateUpgradeCertificateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loyalty_account_id': value['loyaltyAccountId'],
        'program_name': value['programName'],
        'certificate_type': value['certificateType'],
        'total_count': value['totalCount'],
        'remaining_count': value['remainingCount'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'notes': value['notes'],
    };
}

